import { useDocument } from "./useDocument";
import { useWindow } from "./useWindow";
const useCookie = () => {
    const myDocument = useDocument();
    const myWindow = useWindow();
    const setCookie = (name, value, days) => {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = expirationDate.toUTCString();
        myDocument.cookie = `${name}=${value}; expires=${expires}; path=/`;
    };
    const getCookie = (name) => {
        const cookieValue = myDocument.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return cookieValue ? cookieValue.pop() : undefined;
    };
    const removeCookie = (name) => {
        // Get number of days since Jan 01 1970 as reference for removing cookie
        const secondsReset = new Date().getTime() / 86400; // Get value in milliseconds;
        const daysReset = secondsReset / 1000; // Convert value in days;
        setCookie(name, "", -daysReset);
    };
    return {
        setCookie,
        getCookie,
        removeCookie,
        myDocument,
        myWindow
    };
};
export default useCookie;
